module.exports = __webpack_public_path__ + "static/media/logo-nh-large.bab8d00c.svg";